import { isSSR } from '@repo/ui/src/utils/isSSR';

export const waitForAnalytics = () =>
  new Promise<void>((resolve) => {
    if (!isSSR && window.analytics) {
      resolve();
      return;
    }
    let count = 0;
    const interval = setInterval(() => {
      count += 1;
      if ((!isSSR && window.analytics) || count > 10) {
        clearInterval(interval);
        resolve();
      }
    });
  });

type Func = (...args: any[]) => any;

export const track = async <T extends Func>(
  func: T,
  props: Omit<Parameters<T>[0], 'affiliation'>,
) => {
  await waitForAnalytics();
  func({
    affiliation: 'website',
    ...props,
  });
};
